"use client";

import type { TenantIdentity } from "@/config/tenants";
import { useAppLocale } from "@/features/localization/app-locale-provider";
import { CookiePolicyPage } from "@/features/marketing/components/cookie-policy-page";

export function TenantCookiePolicyPage({ tenant }: Readonly<{ tenant: TenantIdentity }>) {
  const { locale } = useAppLocale();

  return <CookiePolicyPage locale={locale} tenant={tenant} />;
}
